import { Typography, Box } from '@mui/material'
import { Form, Formik } from 'formik'
import React, { useCallback, useContext, useMemo, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as yup from 'yup'

import api from 'api'
import { AuthStateContext } from 'context/auth'
import routes from 'routes'
import FormikTextField from 'components/Common/FormikTextField'
import PromiseHandler from 'components/Common/PromiseHandler'
import ResendCodeMessage from 'components/Common/ResendCodeMessage'
import Button from 'components/Common/Button'

// const errorVerificationCodeMessage = 'Invalid verification code, please check your email and try again.'

const schema = yup.object({
  code: yup.string().min(6, 'Code must be at least 6 characters').required('Code is required'),
})

const sx = {
  title: {
    marginBottom: theme => theme.spacing(4),
    lineHeight: '39px',
  },
}

export const PhoneVerificaionForm = ({ onNextStep }) => {
  const navigate = useNavigate()
  const [authState] = useContext(AuthStateContext)
  const { email, code, password } = authState
  const formik = useRef(null)
  const [confirmEmailPromise, setPromise] = useState(null)

  const initialValue = useMemo(() => ({ code: code || '' }), [code])

  const onFormSubmit = useCallback(
    values => {
      if (email && password) {
        const promise = api.confirmSignUpEmail(email.toLowerCase(), values.code)
        setPromise(promise)
      }
    },
    [email, password],
  )

  const onConfirmPhoneSuccess = useCallback(async () => {
    navigate(routes.home)
  }, [navigate])

  const onPromiseError = useCallback(error => {
    formik.current?.setSubmitting(false)
  }, [])

  return (
    <>
      <PromiseHandler promise={confirmEmailPromise} then={onConfirmPhoneSuccess} catch={onPromiseError} />
      <Typography variant="h3" sx={sx.title}>
        Enter Your Authentication Code
      </Typography>
      <Formik innerRef={formik} initialValues={initialValue} onSubmit={onFormSubmit} validationSchema={schema}>
        {({ isSubmitting, isValid }) => {
          return (
            <Form>
              <FormikTextField name="code" label="Authentication Code" fullWidth autoFocus type="password" />
              <Box mt={3} mb={5}>
                <ResendCodeMessage />
              </Box>
              <Button fullWidth loading={isSubmitting} submit>
                Submit
              </Button>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
